import { render, staticRenderFns } from "./preferences-panel.vue?vue&type=template&id=355eb4e0&"
import script from "./preferences-panel.ts?vue&type=script&lang=ts&"
export * from "./preferences-panel.ts?vue&type=script&lang=ts&"
import style0 from "./preferences-panel.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports